module.exports = __webpack_public_path__ + "u7.no2.596193a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/u7.no2.jpg
// module id = WNxe
// module chunks = 0